(ns hai.web-app.util.params
  "Helpers for getting/setting query params")

(defn param-name [o]
  (if (keyword? o)
    (name o)
    (str o)))

(defn query-param
  "Gets a query param from the current URL (address bar). `param` can be string or
  keyword"
  [param]
  (.get (js/URLSearchParams. js/window.location.search)
        (param-name param)))

(defn set-query-param
  "Update a query param, and push a new history entry, so the back button works."
  [param-str value-str]
  (let [url (js/URL. js/window.location)]
    (.set (.-searchParams url) (param-name param-str) (str value-str))
    (js/history.replaceState nil nil url)))
